import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'

@Injectable()
export class NotificationService {
    constructor(private toastr: ToastrService) {}

    showSuccess(message: string) {
        this.toastr.success(message)
    }

    showError(message: string) {
        this.toastr.error(message)
    }

    showSuccessMessages(messages: string[]) {
        messages.forEach((message) => this.toastr.success(message))
    }

    showErrorMessages(messages: string[]) {
        messages.forEach((message) => this.toastr.error(message))
    }

    clear() {
        this.toastr.clear()
    }
}
